(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.sp-header-section');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-ywinspire-product-information"]) return;
  try {
    
  const spFindVariant = (section) => {
    const variantsElement = section.querySelector('[data-sp-variants]');
    if (!variantsElement) return null;
    const variants = JSON.parse(variantsElement.textContent);
    const optionFields = [...section.querySelectorAll('.sp-options fieldset')];
    if (!optionFields.length) return variants[0] || null;
    const values = optionFields.map((field) => field.querySelector('input:checked')?.value);
    return variants.find((item) => item.options.every((value, index) => value === values[index])) || null;
  };

  const spFormatMoney = (section, cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: section.dataset.currency || 'USD',
  }).format(cents / 100);

  const spUpdateVariant = (section) => {
    const variant = spFindVariant(section);
    if (!variant) return null;
    const priceEl = section.querySelector('.sp-price');
    const compareEl = section.querySelector('.sp-price__compare');
    const onSale = variant.compare_at_price > variant.price;
    priceEl?.classList.toggle('sp-price--on-sale', onSale);
    if (compareEl) compareEl.textContent = onSale ? spFormatMoney(section, variant.compare_at_price) : '';
    section.querySelectorAll('[data-sp-variant-compare-price]').forEach((item) => {
      item.textContent = onSale ? spFormatMoney(section, variant.compare_at_price) : '';
      item.toggleAttribute('hidden', !onSale);
    });
    section.querySelectorAll('[data-sp-variant-price]').forEach((item) => {
      item.textContent = spFormatMoney(section, variant.price);
    });
    section.querySelectorAll('form input[name="id"]').forEach((field) => (field.value = variant.id));
    spSetAvailability(section, variant.available);
    return variant;
  };

  const spShowError = (section, message) => {
    section.querySelectorAll('.sp-buy-form__error').forEach((error) => {
      error.textContent = message;
      error.toggleAttribute('hidden', !message);
    });
  };

  const spSetLoading = (section, button, loading) => {
    section.querySelectorAll('.sp-buy-form__button').forEach((item) => {
      item.disabled = loading;
      if (loading) {
        item.setAttribute('aria-busy', 'true');
      } else {
        item.removeAttribute('aria-busy');
      }
    });
    button.classList.toggle('is-loading', loading);
    button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
  };

  const spSetAvailability = (section, available) => {
    section.querySelectorAll('.sp-buy-form__button').forEach((button) => {
      button.disabled = !available;
      if (button.dataset.addLabel) {
        const label = button.querySelector('.sp-buy-form__label');
        if (label) label.textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
      }
    });
  };

  const spInitStickyCart = (section) => {
    const stickyCart = section.querySelector('[data-sp-sticky-cart]');
    const primaryForm = section.querySelector('[data-sp-primary-form]');
    if (!stickyCart || !primaryForm || !('IntersectionObserver' in window)) return;

    const updateVisibility = () => {
      const hasPassedPrimaryForm = primaryForm.getBoundingClientRect().bottom < 0;
      stickyCart.toggleAttribute('hidden', !hasPassedPrimaryForm);
    };
    const observer = new IntersectionObserver(updateVisibility, { threshold: 0 });
    observer.observe(primaryForm);
    updateVisibility();
  };

  document.querySelectorAll('.sp-product').forEach((section) => {
    const variant = spFindVariant(section);
    if (variant) spSetAvailability(section, variant.available);
    spInitStickyCart(section);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.sp-options input');
    if (!input) return;
    const section = input.closest('.sp-product');
    if (section) spUpdateVariant(section);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.sp-buy-form');
    if (!form) return;
    const button = event.submitter || form.querySelector('[data-sp-action]');
    if (!button || !window.routes?.cart_add_url) return;

    event.preventDefault();
    const section = form.closest('.sp-product');
    const variant = spUpdateVariant(section);
    if (variant && !variant.available) return;

    spShowError(section, '');
    spSetLoading(section, button, true);

    const isCheckout = button.dataset.spAction === 'checkout';
    const formData = new FormData(form);
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (cart && !isCheckout) {
      formData.append('sections', cart.getSectionsToRender().map((item) => item.id).join(','));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    try {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const response = await fetch(window.routes.cart_add_url, config);
      const state = await response.json();

      if (state.status) {
        throw new Error(state.description || state.message || window.cartStrings?.error || 'Error');
      }

      if (isCheckout) {
        window.location = `${window.shopUrl}/checkout`;
        return;
      }

      if (cart) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'sp-product-form',
            productVariantId: formData.get('id'),
            cartData: state,
          });
        }
        cart.renderContents(state);
      } else {
        window.location = window.routes.cart_url;
      }
    } catch (error) {
      spShowError(section, error.message);
    } finally {
      spSetLoading(section, button, false);
      if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
      if (variant) spSetAvailability(section, variant.available);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
